import { useState, useEffect } from "react"
import axios from "axios"

axios.defaults.withCredentials = true
const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL //ENV VARIABLE WITH THE DEFAULT URL 


export default function FetchData(url, reload) {

    const tkn = sessionStorage.getItem("urtkn")
    const location = localStorage.getItem('usrlctn')


    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [load, setLoad] = useState(true)


    useEffect(() => {

        async function getData() {

            try {
                const paramData = {
                    location
                }
                const response = await axios.get(`${baseUrl}/${url}`, {
                    headers: { Authorization: `Bearer ${tkn}` },
                    params: paramData
                })

                if (response.status === 200) {
                    setData(response.data)
                } else { throw response }

            } catch (err) {
                setError(err)
            } finally {
                setLoad(false)
            }
        }
        getData()
    }, [url, reload, location])
    return { data, error, load }
}

// frontend/src/services/useFetch.js (Rewritten with @tanstack/react-query)
// import { useQuery } from '@tanstack/react-query'; // Import useQuery
// import axios from 'axios';

// axios.defaults.withCredentials = true;
// const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL;

// export default function FetchData(url) { // No need for 'reload' prop anymore
//     const tkn = sessionStorage.getItem("urtkn");
//     const location = localStorage.getItem('usrlctn');

//     const fetcher = async () => {
//         const paramData = {
//             location
//         };
//         const response = await axios.get(`${baseUrl}/${url}`, {
//             headers: { Authorization: `Bearer ${tkn}` },
//             params: paramData
//         });
//         return response.data;
//     };

//     const { data, error, isLoading, isFetching, refetch } = useQuery({
//         queryKey: [url, location], // Unique key for the query, including dependencies
//         queryFn: fetcher,
//         enabled: !!location // Only run the query if location exists (or any other condition)
//         // staleTime: 5 * 60 * 1000, // Optional: Data is considered fresh for 5 minutes
//         // cacheTime: 10 * 60 * 1000, // Optional: Data stays in cache for 10 minutes
//         // refetchOnWindowFocus: true, // Optional: Refetch when window regains focus
//         // refetchInterval: 60 * 1000, // Optional: Refetch every minute
//     });

//     return { data, error, load: isLoading || isFetching, refetch };
// }